var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8056 21.2802V2.52832L8.22412 10.324L16.8056 21.2802Z",
    fill: "#BC85FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.6984V0L8.22388 10.3241L0 17.6984Z",
    fill: "#85FFC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1905 27.3905L0 17.6985L8.22388 10.3242L16.8053 21.2804L10.1905 27.3905Z",
    fill: "#0064AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.805 21.2802V2.52832L25.3865 10.5347L16.805 21.2802Z",
    fill: "#BC85FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6106 17.9093V0.210938L25.3867 10.535L33.6106 17.9093Z",
    fill: "#85FFC4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4201 27.6012L33.6106 17.9092L25.3867 10.5349L16.8053 21.2804L23.4201 27.6012Z",
    fill: "#0064AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.21d0a7d32af576821e0557c052e4b1f8.svg";
export { ForwardRef as ReactComponent };